var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vld-parent"},[_c('loading',{attrs:{"active":_vm.isLoading,"is-full-page":_vm.fullPage},on:{"update:active":function($event){_vm.isLoading=$event}}},[_c('div',{staticClass:"half-circle-spinner"},[_c('div',{staticClass:"circle circle-1"}),_c('div',{staticClass:"circle circle-2"})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }